<template>
    <el-drawer
        :append-to-body="true"
        :before-close="cancel"
        :title="detail.title"
        :visible.sync="dialogVisible"
        width="500px">
        <div class="flex flex-direction padding-sm">
            <div class="detail" v-html="detail.content"></div>
        </div>
    </el-drawer>
</template>

<script>

import {getTemplateDetail} from "@/api";

export default {
    name: "TemplateDetailDialog",
    components: {},
    data() {
        return {
            detail: ''
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        aid: {
            type: Number,
            default: 0
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
       if (this.aid)this.init()
    },
    methods: {
        async init() {
            let _data = await getTemplateDetail(this.aid)
            this.detail = _data.data
        },
        cancel() {
            this.$emit('watchState', false)
        },
    },
    filters: {},
    watch: {
        aid() {
            if (this.aid)this.init()
        }
    }
}
</script>

<style lang="scss" scoped>

.template-item {
    width: 100%;
    border: 1px solid #eeeeee;

    .operate {
        border-top: 1px solid #eeeeee;
        height: 50px;
    }
}

</style>